/* @ngInject */
export default function (APIService, Upload, AuthService, $http) {
	return {
		...APIService.service('quoting'),

		uploadServices: (file) => {
			return Upload.upload({
				url:     `${process.env.API_ENDPOINT}quoting/upload-services`,
				data:    {
					file: file,
				},
				headers: {
					Authorization: `Bearer ${AuthService.getToken()}`,
				},
			});
		},

		uploadPublicHolidays: (file) => {
			return Upload.upload({
				url:     `${process.env.API_ENDPOINT}quoting/upload-public-holidays`,
				data:    {
					file: file,
				},
				headers: {
					Authorization: `Bearer ${AuthService.getToken()}`,
				},
			});
		},

		getDownloadURLForPublicHolidays: () => {
			return `${process.env.API_ENDPOINT}quoting/download-public-holidays?token=${AuthService.getToken()}`;
		},

		calculateQuote: (data) => {
			return $http.post(`${process.env.API_ENDPOINT}quoting/calculate-quote?include=formattedShifts`, data);
		},

		deleteQuote: (uuid) => {
			return $http.delete(`${process.env.API_ENDPOINT}quoting/` + uuid);
		},

		services: () => {
			return {
				...APIService.service('quoting/services'),
			};
		},

		getEnquiries: () => {
			return {
				...APIService.service('enquiries'),
			};
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/factories/quoting/index.js